import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/MichalDiaz_Home/video.jpg';
import subs from '@/static/assets/reviews/MichalDiaz_Home/subs.vtt';

export const MichalDiaz: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Home, ReviewProduct.All],
  reviewerName: 'Michal',
  videoUrl: `${ASSETS_URL}/home/MichalDiaz_Home.webm`,
  posterUrl: poster,
  captionsUrl: subs,
  displayInHomePage: true,
};
